import { generateReducer } from 'services/redux-entity';
import { CONSTS } from '../../constants';

const initialState = {
  answersById: {},
  answers: {
    fetching: false,
    ids: [],
    page: 1,
    nextPage: 1,
    total: 0,
    orderBy: 'createdAt',
    order: 'DESC',
    filters: [],
  },
  missesById: {},
  misses: {
    fetching: false,
    ids: [],
    page: 1,
    nextPage: 1,
    total: 0,
    orderBy: 'createdAt',
    order: 'ASC',
    filters: [],
  },
  suggestedOpportunities: [],
  selectedOpportunity: null,
  botsById: {},
  bots: {
    fetching: false,
    ids: [],
    page: 1,
    nextPage: 1,
    total: 0,
    orderBy: 'createdAt',
    order: 'DESC',
  },
  skillsById: {},
  skills: {
    fetching: false,
    ids: [],
    page: 1,
    nextPage: 1,
    total: 0,
    orderBy: 'createdAt',
    order: 'DESC',
    filters: [],
  },
  deltasById: {},
  deltas: {
    fetching: false,
    ids: [],
    page: 1,
    nextPage: 1,
    total: 0,
    orderBy: 'createdAt',
    order: 'DESC',
  },
  importsById: {},
  imports: {
    fetching: false,
    ids: [],
    page: 1,
    nextPage: 1,
    total: 0,
    orderBy: 'createdAt',
    order: 'DESC',
  },
};

const reductions = {
  SET_SELECTED_OPPORTUNITY: (state, { payload: selectedOpportunity }) => {
    return { ...state, selectedOpportunity };
  },
  SET_SUGGESTED_OPPORTUNITIES: (state, { payload: suggestedOpportunities }) => {
    return { ...state, suggestedOpportunities };
  },
  STARTED_FETCHING_ANSWER: (state, { payload }) => {
    const { id } = payload;
    return state;
  },
  FETCHED_ANSWER: (state, { payload }) => {
    const { id, data } = payload;
    const answersById = Object.assign({}, state.answersById, { [id]: data });
    return Object.assign({}, state, { answersById });
  },
  FETCHED_SKILL: (state, { payload }) => {
    const { id, data } = payload;
    const skillsById = Object.assign({}, state.skillsById, { [id]: data });
    return Object.assign({}, state, { skillsById });
  },
  FAILED_FETCHING_ANSWER: (state, { payload }) => {
    const { error } = payload;
    return state;
  },
  STARTED_UPDATING_ANSWER: (state, { payload }) => {
    const { answer } = payload;
    return state;
  },
  UPDATED_ANSWER: (state, { payload }) => {
    const { answer } = payload;
    const answersById = Object.assign({}, state.answersById, {
      [answer.id]: answer,
    });
    return Object.assign({}, state, { answersById });
  },
  FAILED_UPDATING_ANSWER: (state, { payload }) => {
    const { error, answer } = payload;
    return state;
  },

  STARTED_CREATING_ANSWER: (state, { payload }) => {
    const { answer } = payload;
    return state;
  },
  CREATED_ANSWER: (state, { payload }) => {
    const { answer } = payload;
    const answersById = Object.assign({}, state.answersById, {
      [answer.id]: answer,
    });
    return Object.assign({}, state, { answersById });
  },
  FAILED_CREATING_ANSWER: (state, { payload }) => {
    const { error, answer } = payload;
    return state;
  },
  ADDED_ANSWER_TAG: (state, { payload }) => {
    const { id, data } = payload;
    const answer = Object.assign({}, state.answersById[id], {
      bot_tag_ids: state.answersById[id].bot_tag_ids.concat(data),
    });
    const answersById = Object.assign({}, state.answersById, { [id]: answer });
    return Object.assign({}, state, { answersById });
  },
  REMOVED_ANSWER_TAG: (state, { payload }) => {
    const { id, data } = payload;
    const answer = Object.assign({}, state.answersById[id], {
      bot_tag_ids: state.answersById[id].bot_tag_ids.filter(
        (tag) => tag !== data
      ),
    });
    const answersById = Object.assign({}, state.answersById, { [id]: answer });
    return Object.assign({}, state, { answersById });
  },
  ADDED_SKILL_TAG: (state, { payload }) => {
    const { id, data } = payload;
    const skill = Object.assign({}, state.skillsById[id], {
      bot_tag_ids: state.skillsById[id].bot_tag_ids.concat(data),
    });
    const skillsById = Object.assign({}, state.skillsById, { [id]: skill });
    return Object.assign({}, state, { skillsById });
  },
  REMOVED_SKILL_TAG: (state, { payload }) => {
    const { id, data } = payload;
    const skill = Object.assign({}, state.skillsById[id], {
      bot_tag_ids: state.skillsById[id].bot_tag_ids.filter(
        (tag) => tag !== data
      ),
    });
    const skillsById = Object.assign({}, state.skillsById, { [id]: skill });
    return Object.assign({}, state, { skillsById });
  },
  DELETE_TAG_CLEANUP: (state, { payload }) => {
    const { id } = payload;
    // Answers
    const answersById = state.answersById;
    Object.keys(state.answersById).forEach((answerId) => {
      answersById[answerId] = Object.assign({}, state.answersById[answerId], {
        bot_tag_ids: state.answersById[answerId].bot_tag_ids.filter(
          (tag) => tag !== id
        ),
      });
    });
    // Skills
    const skillsById = state.skillsById;
    Object.keys(state.skillsById).forEach((skillId) => {
      skillsById[skillId] = Object.assign({}, state.skillsById[skillId], {
        bot_tag_ids: state.skillsById[skillId].bot_tag_ids.filter(
          (tag) => tag !== id
        ),
      });
    });
    return Object.assign({}, state, { answersById }, { skillsById });
  },

  STARTED_UPDATING_DELTA: (state, { payload }) => {
    const { delta } = payload;
    return state;
  },

  ADDED_NEW_BOT: (state, { payload }) => {
    const { bot } = payload;
    const botsById = Object.assign({}, state.botsById, { [bot.id]: bot });
    return Object.assign({}, state, { botsById });
  },

  UPDATED_BOT: (state, { payload }) => {
    const { bot } = payload;
    const botsById = Object.assign({}, state.botsById, { [bot.id]: bot });
    return Object.assign({}, state, { botsById });
  },

  UPDATED_BOT_IMPORT_ID: (state, { payload }) => {
    const { id, bot_import_id } = payload;
    const bot = Object.assign({}, state.botsById[id], {
      bot_import_id: bot_import_id,
    });
    const botsById = Object.assign({}, state.botsById, { [id]: bot });
    return Object.assign({}, state, { botsById });
  },

  UPDATED_DELTA: (state, { payload }) => {
    const { delta } = payload;
    const deltasById = Object.assign({}, state.deltasById, {
      [delta.id]: delta,
    });
    return Object.assign({}, state, { deltasById });
  },

  APPROVE_ALL_DELTAS: (state) => {
    const deltasById = {};
    Object.keys(state.deltasById).forEach((id) => {
      deltasById[id] = Object.assign({}, state.deltasById[id], {
        review_status: CONSTS.DELTA_REVIEW_STATUS_APPROVED,
      });
    });
    return Object.assign({}, state, { deltasById });
  },

  REJECT_ALL_DELTAS: (state) => {
    const deltasById = {};
    Object.keys(state.deltasById).forEach((id) => {
      deltasById[id] = Object.assign({}, state.deltasById[id], {
        review_status: CONSTS.DELTA_REVIEW_STATUS_REJECTED,
      });
    });
    return Object.assign({}, state, { deltasById });
  },

  FAILED_UPDATING_DELTA: (state, { payload }) => {
    const { error, delta } = payload;
    return state;
  },

  UPDATED_IMPORT_COUNT: (state, { payload }) => {
    const { id, delta } = payload;
    const counts = state.importsById[id].counts.map((c) => {
      if (
        c.review_status === CONSTS.DELTA_REVIEW_STATUS_APPROVED &&
        delta.review_status === CONSTS.DELTA_REVIEW_STATUS_APPROVED
      )
        c.count = Number(c.count) + 1;
      if (
        c.review_status === CONSTS.DELTA_REVIEW_STATUS_REJECTED &&
        delta.review_status === CONSTS.DELTA_REVIEW_STATUS_REJECTED
      )
        c.count = Number(c.count) + 1;
      if (c.review_status === CONSTS.DELTA_REVIEW_STATUS_NOT_REVIEWED)
        c.count = Number(c.count) - 1;
      return c;
    });
    const _import = Object.assign({}, state.importsById[id], { counts });
    const importsById = Object.assign({}, state.importsById, { [id]: _import });
    return Object.assign({}, state, { importsById });
  },

  UPDATED_IMPORT_COUNT_APPROVE_ALL: (state, { payload }) => {
    const { id } = payload;
    const counts = state.importsById[id].counts.map((c) => {
      if (c.review_status === CONSTS.DELTA_REVIEW_STATUS_APPROVED)
        c.count = state.importsById[id].counts.total;
      if (
        c.review_status === CONSTS.DELTA_REVIEW_STATUS_REJECTED ||
        c.review_status === CONSTS.DELTA_REVIEW_STATUS_NOT_REVIEWED
      )
        c.count = 0;
      return c;
    });
    const _import = Object.assign({}, state.importsById[id], { counts });
    const importsById = Object.assign({}, state.importsById, { [id]: _import });
    return Object.assign({}, state, { importsById });
  },

  UPDATED_IMPORT_COUNT_REJECT_ALL: (state, { payload }) => {
    const { id } = payload;
    const counts = state.importsById[id].counts.map((c) => {
      if (c.review_status === CONSTS.DELTA_REVIEW_STATUS_REJECTED)
        c.count = state.importsById[id].counts.total;
      if (
        c.review_status === CONSTS.DELTA_REVIEW_STATUS_APPROVED ||
        c.review_status === CONSTS.DELTA_REVIEW_STATUS_NOT_REVIEWED
      )
        c.count = 0;
      return c;
    });
    const _import = Object.assign({}, state.importsById[id], { counts });
    const importsById = Object.assign({}, state.importsById, { [id]: _import });
    return Object.assign({}, state, { importsById });
  },

  ...generateReducer('answers'),
  ...generateReducer('misses'),
  ...generateReducer('bots'),
  ...generateReducer('skills'),
  ...generateReducer('deltas'),
  ...generateReducer('imports'),
};

const botsRouteReducer = (state = initialState, action) => {
  if (action && action.type && reductions[action.type]) {
    return reductions[action.type](state, action);
  }
  return state;
};

export default botsRouteReducer;
